var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',_vm._l((_vm.links),function(link){return _c('navLink',{key:link.name,attrs:{"name":link.name,"links":_vm.links,"href":link.href,"id":link.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }